import React from 'react';
import PropTypes from 'prop-types';
import InlineEdit from 'react-edit-inline';
import Icon from 'components/widgets/Icon';

/**
 * Renders an optionally editable Title with an icon for use in the config
 * panel.
 */
class Title extends React.Component {
	render() {
		const {
			name,
			editable,
			invalid,
			icon,
			onChange
		} = this.props;

		let text;
		let pencil;
		if (editable) {
			text = (
				<InlineEdit
					className="text"
					activeClassName="active-text"
					text={name}
					paramName="name"
					change={onChange}
				/>
			);
			pencil = <Icon src="icon-GG-pencil" />;
		} else {
			text = (
				<span className="inactive-text" title={name}>{name}</span>
			);
		}

		return (
			<div className="node-title">
				<div className={`node-name${invalid ? ' error' : ''}`}>
					<Icon src={icon} />
					{text}
					{pencil}
				</div>
			</div>
		);
	}
}

Title.defaultProps = {
	editable: true,
	icon: 'icon-GG-code'
};

Title.propTypes = {
	/**
	 * The title name.
	 */
	name: PropTypes.string.isRequired,
	/**
	 * Indicates that the title should be editable.  When specified, you must
	 * also include `onChange`.  Defaults to true.
	 */
	editable: PropTypes.bool,
	/**
	 * Indicates that the title should be rendered invalid.
	 */
	invalid: PropTypes.bool,
	/**
	 * The icon to display with the title.  Defaults to `icon-GG-code`.
	 */
	icon: PropTypes.string,
	/**
	 * A change event handler that is fired when the title is changed.  Only
	 * used if `editable` is true.
	 */
	onChange: PropTypes.func
};

export default Title;
